<checkout-header [host]="host" [cart]="cart" [canProceed]="canProceed()"
  (back)="back()" (next)="next()"
  [step]="getNextStep()"></checkout-header>

<main class="container" *ngIf="menu && cart && cart.isValidated">

  <h5 class="mt-3" i18n>Review your order</h5>

  <opening-hours-warning [host]="host" [table]="table"></opening-hours-warning>

  <div class="mt-3 alert alert-warning" role="alert"
    *ngIf="table.type != TableType.inhouse && (!host.has_delivery && host.has_takeout) && !host.order_note_1">
    <div i18n>There is no delivery service right now, but you can pick up your order at the restaurant.</div>
  </div>

  <div class="mt-3 mb-3" *ngIf="host.order_note_1" [innerHTML]="host.order_note_1"></div>

  <div class="list-group mb-3">
    <div *ngFor="let entry of cart.positions"
      (click)="onSelect(entry)"
      class="list-group-item list-group-item-action cart-entry" [class.disabled]="entry.count == 0">
      <div class="row">
        <div class="col-8">
          <div>{{ entry.count }} &times; {{ entry.getNameWithVariant() }}</div>
          <div class="font-italic entry-comment" *ngIf="entry.comment && activeEntry == null"><span
            i18n>Note:</span> {{ entry.comment }}</div>
        </div>
        <div [class]="{'col-4': entry==activeEntry, 'col-3': entry!=activeEntry}"
          class="text-right entry-price">{{ entry.getPrice()|currency:host}}</div>
        <div class="col-1 pl-0 pr-0 text-center" *ngIf="entry != activeEntry"><i class="fas fa-pencil-alt"></i></div>
      </div>
      <div class="font-italic entry-choice" *ngFor="let choice of entry.getChoices()">
        {{ choice.name }}: <b>{{ choice.selected }}</b>
      </div>
      <div class="font-italic entry-options" *ngIf="entry.option_ids.length > 0"><span i18n>Options</span>: {{ entry.getOptions() }}</div>
      <div class="row" *ngIf="entry == activeEntry && entry.item.allow_freetext">
        <div class="col mt-3">
          <div class="form-group">
            <label for="id_note" class="sr-only" i18n>Note</label>
            <textarea id="id_note" placeholder="Note" i18n-placeholder class="form-control hide-validation-status"
              [(ngModel)]="entry.comment"></textarea>
          </div>
        </div>
      </div>
      <div class="row" *ngIf="entry == activeEntry">
        <div class="col mt-1">
          <button class="btn btn-sm btn-outline-success" (click)="addOne($event, entry)"><i class="fa fa-plus"></i>
          </button>&nbsp;
          <button class="btn btn-sm btn-outline-danger" (click)="removeOne($event, entry)" [disabled]="entry.count < 2">
            <i class="fa fa-minus"></i></button>
        </div>
        <div class="col mt-1 text-right">
          <button class="btn btn-sm btn-danger" (click)="removeAll($event, entry)"><i class="fa fa-trash"></i></button>
          &nbsp;
          <button class="btn btn-sm btn-success" (click)="unselect($event)"><i class="fa fa-check"></i></button>
        </div>
      </div>
      <div class="row" *ngIf="entry.checkConstraint(cart.getDeliveryTime().dt) as constraint">
        <div class="col text-danger small bold">
          <i class="fa fa-exclamation-triangle"></i> {{ constraint.label }}
        </div>
      </div>
    </div>
    <div class="list-group-item" *ngIf="cart.getDeliveryFee()">
      <div class="row">
        <div class="col" i18n>Delivery fee</div>
        <div class="col-auto">{{ cart.getDeliveryFee()|currency:host }}</div>
      </div>
    </div>
    <discount-entry *ngFor="let entry of cart.discounts"
      (click)="onDiscountClick(entry)" class="list-group-item" [showSelection]="true"
      [ngClass]="{'list-group-item-action': entry.needsSelection()}"
      [entry]="entry" [pastTense]="true"></discount-entry>
    <voucher-entry *ngFor="let entry of cart.vouchers"
      (click)="onDiscountClick(entry)" class="list-group-item" [showSelection]="true"
      [ngClass]="{'list-group-item-action': entry.needsSelection()}"
      [entry]="entry" [pastTense]="true"></voucher-entry>
    <div class="list-group-item order-total">
      <div class="row font-weight-bold">
        <div class="col" i18n>Total</div>
        <div class="col-auto">{{ cart.getTotal()|currency:host }}</div>
      </div>
    </div>
  </div>
  <div class="card mb-3 contact-data" (click)="onContactClick()"
    *ngIf="table.type != TableType.inhouse || host.contact_data_inhouse">
    <div class="card-header">
      <div class="row">
        <div class="col"><i class="fas fa-user"></i>&nbsp;<span i18n>Contact Data</span></div>
        <div class="col-auto text-right"><i class="fas fa-pencil-alt"></i></div>
      </div>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-12">
          <i class="fas fa-fw fa-user"></i> {{ cart.address.name }}
        </div>
        <div class="col-12" *ngIf="cart.address.email">
          <i class="fas fa-fw fa-envelope"></i> {{ cart.address.email }}
        </div>
        <div class="col-12" *ngIf="cart.address.phone">
          <i class="fas fa-fw fa-phone-alt"></i> {{ cart.address.phone }}
        </div>
        <div class="col-12" *ngIf="cart.address.notes && cart.address.notes.length > 0">
          <i class="fas fa-fw fa-comment-alt"></i> {{ cart.address.notes }}
        </div>
      </div>
    </div>
  </div>
  <!-- delivery or takeout? -->
  <div class="card mb-3 order-method" (click)="onDeliveryClick()" *ngIf="cart.method != 'i'">
    <div class="card-header">
      <div class="row">
        <div class="col" *ngIf="cart.method == OrderMethod.delivery"><i
          class="fas fa-fw fa-shipping-fast"></i>&nbsp;<span i18n>Delivery</span></div>
        <div class="col" *ngIf="cart.method == OrderMethod.takeout"><i
          class="fas fa-fw fa-shopping-bag"></i>&nbsp;<span i18n>Takeout</span></div>
        <div class="col-auto text-right" *ngIf="host.has_delivery"><i
          class="fas fa-pencil-alt"></i></div>
      </div>
    </div>
    <div class="card-body">
      <p class="card-text" *ngIf="cart.method == OrderMethod.delivery" i18n>Your order will be delivered
        to the following address:<br><br>{{ addressStr }}</p>
      <min-amount-warning
        [host]="host" [result]="cart.checkMinOrderAmount()" *ngIf="cart.method == OrderMethod.delivery"></min-amount-warning>
      <p class="card-text" *ngIf="cart.method == OrderMethod.takeout" i18n>You pick up your order at the restaurant:<br><br>
        {{ host.address }}.</p>
    </div>
  </div>

  <!-- time selection -->
  <div class="card mb-3 order-time" (click)="onTimeClick()" *ngIf="cart.canPreorder()">
    <div class="card-header">
      <div class="row">
        <div class="col"><i class="fas fa-clock fa-fw"></i>&nbsp;
          <span *ngIf="cart.method==OrderMethod.delivery" i18n>Delivery Time</span>
          <span *ngIf="cart.method==OrderMethod.takeout" i18n>Takeout Time</span>
        </div>
        <div class="col-auto text-right"><i class="fas fa-pencil-alt"></i></div>
      </div>
    </div>
    <div class="card-body">
      <p class="card-text" *ngIf="!cart.desired_time" i18n>As soon as possible,
        expected {{ estimatedArrivalTime }}.</p>
      <p class="card-text" *ngIf="cart.desired_time>0" i18n>{{ dayStr }}, at {{ timeStr }}</p>
    </div>
  </div>

  <div class="card mb-3 payment-method" (click)="onPaymentClick()" *ngIf="cart.canSelectPayment()">
    <div class="card-header">
      <div class="row">
        <div class="col"><i class="fas fa-coins fa-fw"></i>&nbsp;<span i18n>Payment</span></div>
        <div class="col-auto text-right"><i class="fas fa-pencil-alt"></i></div>
      </div>
    </div>
    <div class="card-body">
      <p class="card-text">{{ cart.selectedPaymentText }}</p>
    </div>
  </div>

  <div class="card mb-3" *ngIf="host.has_discount_codes">
    <div class="card-header">
      <div class="row">
        <div class="col"><i class="fas fa-ticket-alt fa-fw"></i>&nbsp;<span i18n>Voucher / Discount Code</span></div>
        <div class="col-auto text-right"></div>
      </div>
    </div>
    <div class="card-body text-center">
      <a class="btn btn-dark" [routerLink]="'/checkout/code'" i18n>Enter Code</a>
    </div>
  </div>

  <div class="mt-3 mb-3 row">
    <div class="col-5 text-left">
      <button class="btn btn-secondary" (click)="back()"><i class="far fa-arrow-alt-circle-left"></i>&nbsp;<span
        i18n>Back</span></button>
    </div>
    <div class="col-7 text-right">
      <next-step-button [step]="getNextStep()" [enabled]="canProceed()" [cart]="cart"
        (next)="next()"></next-step-button>
    </div>
  </div>

</main>
